(function($){
	//Handle the mobile menu toggling
	$(".menu-toggle").click(function() {
		menuToggle();
	});

	function menuToggle() {
		$(".menu-toggle").toggleClass("cross");
		$("body").toggleClass("modal-open");
		$("#mobile-navigation").toggleClass("open");
	}
})(jQuery);
